// extracted by mini-css-extract-plugin
module.exports = {"label":"radioFormProjectPage_label___Y_zY"};
    if(module.hot) {
      // 1790670320743
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  